import request from '@/utils/request'

// 根据站点id查询当前用户拥有的流程节点
export function getPowerNode(url,siteId) {
  return request({
    url: url+'/flowNode/getPowerNode/'+siteId,
    method: 'get',
  })
}




// WEBPACK FOOTER //
// ./src/api/system/flowNode.js